import { render, staticRenderFns } from "./ExchangeRates.vue?vue&type=template&id=66eda434&"
import script from "./ExchangeRates.vue?vue&type=script&lang=js&"
export * from "./ExchangeRates.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRates.vue?vue&type=style&index=0&id=66eda434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports